exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-list[data-v-2e6df7c4] {\n  background: rgba(240, 246, 255, 0.3490196078);\n  border: 1px solid rgba(215, 218, 220, 0.6509803922);\n  border-radius: 5px;\n  margin: 6px;\n  padding: 12px;\n  cursor: pointer;\n  -webkit-transition: 0.25s ease-in-out all;\n  transition: 0.25s ease-in-out all;\n}\n.box-list[data-v-2e6df7c4]:hover {\n  background: #eff5ff;\n}\n.box-list--body[data-v-2e6df7c4] {\n  padding: 2px 14px;\n}", ""]);

// exports
